import React, { Component } from 'react';
import InnerHTML from 'dangerously-set-html-content';
import $ from 'jquery';
// import { isEmpty } from 'lodash'
import WBreadCrumb from '../WBreadCrumb/WBreadCrumb';
import './FAQs.css';
import WSpinner from '../WSpinner/WSpinner';
import envConfig from 'env/EnvConfig';
import { FAQ_CONTENT_LOAD_DELAY, FAQ_MOBILE_BREAKPOINT } from '../Constants';

class FAQWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
            spinner: false,
            breadCrumbValues: [],
        };
    }

    componentDidMount() {
        const role = localStorage.getItem('role');
        let userRole = false;
        userRole = role === 'Member' || false;
        const breadCrumbs = { name: 'Home', url: `${userRole ? '/accountholder' : '/accountguestview'}`,dataAnalyticId:"FAQ_BREADCRUMB_HOME" };
        this.setState(state => ({
            ...state,
            breadCrumbValues: [...state.breadCrumbValues, breadCrumbs],
        }));

        this.loadData(`${envConfig.ENV_URL}/vcm-experience-fragments/vcm-faq-details/master.html`);
    }

   loadData = url => {
    this.setState(state => ({ ...state, spinner: true }));
    fetch(url, {
        method: 'GET',
        headers: {
            Authorization: `${envConfig.PRELOGIN_HEADER_AUTH}`,
        },
    })
        .then(response => {
            if (response.ok) {
                return response.text();
            }
            throw new Error('Error message.');
        })
        .then(data => {
            let result = data.toString();
            result = result.replace(/<script[^>]*>/gi, ' <!-- ');
            result = result.replace(/<\/script>/gi, ' --> ');
            result = result.replace(/\/etc/g, `${envConfig.ENV_URL}/etc`);
            result = result.replace(/\/content/g, `${envConfig.ENV_URL}/content`);
            this.setState(state => ({ ...state, content: result }));
            setTimeout(() => {
                let jsonText = JSON.parse($('.json-data').text());

                jsonText.forEach((faq, i) => {
                    // Build sidebar links
                    const listElements = $("<p>").append(
                        $("<a>")
                            .attr("href", "#")
                            .attr("id", "refId" + i)
                            .addClass("groupNameCheck")
                            .text(faq.groupName)
                    );
                    $("#showallfaq .card-body").append(listElements);

                    // Container for each group
                    const segregation = $("<div>")
                        .addClass("acc-segregation")
                        .attr("data-group", "refId" + i);

                    const heading = $("<h3>")
                        .addClass("blueHdng-greenBorder")
                        .text(faq.groupName);

                    segregation.append(heading);

                    const faqList = faq.faqList;

                    faqList.forEach((ques, index) => {
                        // Build card safely with DOM APIs
                        const card = $("<div>").addClass("card");
                        if (index === 0) {
                            card.addClass("first-card");
                        }

                        const header = $("<div>")
                            .addClass("card-header collapsed")
                            .attr({
                                "data-toggle": "collapse",
                                "href": `#collapse${i}${index}`,
                                "aria-expanded": "false",
                            });

                        const link = $("<div>")
                            .addClass("card-link")
                            .text(ques.question);

                        const icon = $("<div>")
                            .addClass("accordionIconMain accordionPlusIcon");

                        header.append(link, icon);

                        const collapse = $("<div>")
                            .attr("id", `collapse${i}${index}`)
                            .addClass("collapse")
                            .attr("data-parent", "#accordion");

                        const body = $("<div>")
                            .addClass("card-body")
                            .text(ques.answer);

                        collapse.append(body);
                        card.append(header, collapse);
                        segregation.append(card);
                    });

                    if ($(window).width() < FAQ_MOBILE_BREAKPOINT && faqList.length > 4) {
                        const seeall = $("<p>")
                            .addClass("seeall")
                            .append(
                                $("<a>")
                                    .attr("href", "#")
                                    .addClass("loadMore")
                                    .text("See all")
                            );
                        segregation.append(seeall);
                    }

                    $(".accordionContainer").append(segregation);
                });

                // Keep your existing event handlers unchanged
                $(".loadMore").each(function () {
                    $(this).parents(".acc-segregation").find(".closeall").hide();
                    $(this).parents(".acc-segregation").find(".card").hide();
                    $(this).parents(".acc-segregation").find(".card").slice(0, 4).show();
                });

                $(".loadMore").on("click", function () {
                    $(this).parents(".acc-segregation").find(".closeall").show();
                    $(this).parents(".acc-segregation").find(".card:hidden").slideDown();
                    $(this).parents(".acc-segregation").find(".seeall").hide();
                });

                $(document).one("click", "a.groupNameCheck", function () {
                    $("<p>")
                        .append(
                            $("<span>").append(
                                $("<a>")
                                    .attr("href", "#")
                                    .attr("id", "bcktoshow")
                                    .text("Show all FAQ")
                            )
                        )
                        .insertBefore("#showallfaq p:first-child");
                });

                $(document).on("click", "a.groupNameCheck", function () {
                    let tmpName = $(this).attr("id");
                    $("a.groupNameCheck").parent().show();
                    $(this).parent().hide();
                    $("#bcktoshow").parents("p").show();
                    let chu = $(this).text();
                    $("#showing").text(chu);
                    $("div.acc-segregation").hide();

                    $("#showallfaq").removeClass("show");
                    $(".card-header.acc-title").attr("aria-expanded", "false").addClass("collapsed");

                    $(`div.acc-segregation[data-group=${tmpName}]`)
                        .show()
                        .attr("style", "margin-top: 25px !important;margin-bottom: 20px");

                    $(`div.acc-segregation[data-group=${tmpName}] .blueHdng-greenBorder`).hide();

                    $("#bcktoshow").click(function () {
                        $("a.groupNameCheck").parent().show();
                        $(this).parent().parent().hide();
                        $("#showallfaq").removeClass("show");
                        $("#showing").html("Showing all FAQ");
                        $(".card-header.acc-title").attr("aria-expanded", "false").addClass("collapsed");
                        $("div.acc-segregation").removeAttr("style");
                        $("div.acc-segregation .blueHdng-greenBorder").show();
                    });

                    if ($(".faqdetails").length) {
                        $(".faqdetails").parents(".content-wrapper").addClass("faq-wrapper");
                    }
                });

                this.setState(state => ({ ...state, spinner: false }));
            }, FAQ_CONTENT_LOAD_DELAY);
        })
        .catch(err => {
            this.setState(state => ({
                ...state,
                spinner: false,
                content: err || "Sorry!!! Cross Browser Issue",
            }));
        });
};

    render() {
        const { content, spinner, breadCrumbValues } = this.state;
        return (
            <div className="container">
                <WSpinner loading={spinner} />

                <WBreadCrumb breadCrumbItems={breadCrumbValues} activeCrumb="FAQs" />
                <vcm-help id="vcm-faq">
                    {' '}
                    <InnerHTML html={content} />{' '}
                </vcm-help>
            </div>
        );
    }
}

export default FAQWidget;
